var scroll = require('./_scroll')
var popup = require('./_popup')
var accordion = require('./accordion')
var accordion = require('./fathom')
var loadmore = require('./_load_more')
var Sticky = require('sticky-js')

var getParameterByName = function(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
!(function(window, document, $, undefined) {
  'use strict'
  $(document).ready(function() {
    scroll.init($)
    popup.init($)
    $('.menu-item-has-children > a').on('click', function(e) {
      e.preventDefault()
      $('.menu-item-has-children').removeClass('active')
      var $this = $(this)
      $this.parent().toggleClass('active')
    })

    $('.menu-toggle').on('click', function(e) {
      e.preventDefault()
      $('body').toggleClass('mobile-menu')
    })

    $('.service-area-button .wp-block-button').on('click', function(e) {
      e.preventDefault()
      $('.area-switcher').fadeToggle()
    })

    window.livesearch = function() {
      // Declare variables
      var input, filter, ul, li, a, i, txtValue
      input = document.getElementById('search')
      filter = input.value.toUpperCase()
      ul = document.getElementById('faq-list')
      li = ul.getElementsByClassName('faq-item')
      // Loop through all list items, and hide those who don't match the search query
      for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByClassName('uk-accordion-title')[0]
        txtValue = a.textContent || a.innerText
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          li[i].style.display = ''
        } else {
          li[i].style.display = 'none'
        }
      }
    }
  })
})(window, document, jQuery)
